const DataBooks = {
  books: [
    {
      number: 15,
      name: "Taras",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book",
      img: "none"
    },
    {
      number: 14,
      name: "Martin",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book",
      img: "none"
    },
    {
      number: 13,
      name: "Mario",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book",
      img: "none"
    },
    {
      number: 12,
      name: "Nikita",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book",
      img: "none"
    },
    {
      number: 11,
      name: "Arvid",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book",
      img: "none"
    },
    {
      number: 10,
      name: "Max",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book",
      label: "new"
    },
    {
      number: 9,
      name: "Alex",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book",
      img: "none"
    },
    {
      number: 8,
      name: "Panda",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book",
      img: "none"
    },
    {
      number: 7,
      name: "McBat",
      descr: "6 pages + bonus. Cars, monsters, space and aliens etc. The very new feature in this book is a bonus pocket - the pocket on the back, with 8 memory cards (4 pairs) - the game aka 'Mahjong', will help your child to develop the memory skills via playing.",
      type: "book",
      price: "700"
    },
    {
      number: 6,
      name: "Platon",
      descr: "6 pages. This colorful book was sewed for a boy with the beautiful and rare name Platon. All the pages were chosen by the girl that decided to make a present for a little boy.",
      type: "book"
    },
    {
      number: 5,
      name: "Fly",
      descr: "6 pages. This book was designed and sewed for a girl. The pages are bright and interesting as usual. The fly's eyes on the cover move. Every page have different tasks and themes.",
      type: "book",
      price: "600"
    },
    {
      number: 4,
      name: "Ryboolba",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book"
    },
    {
      number: 3,
      name: "Vanja",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book"
    },
    {
      number: 2,
      name: "Owlenko",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book"
    },
    {
      number: 1,
      name: "Giradlo",
      descr: "NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!! NEED DESCRIPTION!!!",
      type: "book"
    }
  ],
  all: function() { return this.books },
  get: function(id) {
    const isBook = p => p.number === id
    return this.books.find(isBook)
  }
}

export default DataBooks



// WEBPACK FOOTER //
// ./src/components/API_Books.js